(() => {
  const loadRecommendations = async (section) => {
    if (!section?.dataset?.url || section.dataset.khRelatedLoading === 'true') return;
    if (section.querySelector('[data-kh-related-content]')) return;

    section.dataset.khRelatedLoading = 'true';

    try {
      const response = await fetch(section.dataset.url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`Related-products request failed with status ${response.status}.`);
      }

      const responseText = await response.text();
      const parsed = new DOMParser().parseFromString(responseText, 'text/html');
      const incoming = parsed.getElementById(section.id);
      const content = incoming?.querySelector('[data-kh-related-content]');

      if (!incoming || !content) {
        section.remove();
        return;
      }

      section.replaceWith(incoming);
    } catch (error) {
      console.warn('Unable to load related products.', error);
      section.removeAttribute('data-kh-related-loading');
      section.setAttribute('aria-busy', 'false');
    }
  };

  const initializeRecommendations = (scope = document) => {
    scope.querySelectorAll('[data-kh-fast-related]').forEach(loadRecommendations);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeRecommendations(), { once: true });
  } else {
    initializeRecommendations();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeRecommendations(event.target);
  });
})();
